export const PrivacyPolicy = () => (
  <div className="space-y-6">
    <section>
      <h3 className="font-semibold">Política de Privacidade</h3>
      <p className="text-xs text-muted-foreground">
        Última atualização: 01/02/26
      </p>
    </section>

    <p>
      A <strong>Neo Modelos</strong> respeita a privacidade de seus usuários e está
      comprometida com a proteção dos dados pessoais tratados por meio de sua
      plataforma, em conformidade com a Lei Geral de Proteção de Dados
      (Lei nº 13.709/2018 – LGPD).
    </p>

    <p>
      Ao utilizar a plataforma, o usuário declara estar ciente e de acordo com
      esta Política de Privacidade.
    </p>

    <section>
      <h4 className="font-semibold">1. Dados Coletados</h4>
      <p>
        A Neo Modelos coleta apenas os dados estritamente necessários para o
        funcionamento da plataforma.
      </p>

      <h5 className="font-medium mt-2">1.1. Dados fornecidos pelo usuário</h5>
      <ul className="list-disc pl-5 space-y-1">
        <li>Endereço de e-mail para criação de conta, comunicação e suporte;</li>
        <li>
          Informações inseridas voluntariamente pelo usuário nos modelos de
          documentos.
        </li>
      </ul>

      <h5 className="font-medium mt-2">1.2. Dados inseridos em documentos</h5>
      <ul className="list-disc pl-5 space-y-1">
        <li>Inseridos exclusivamente pelo usuário;</li>
        <li>De responsabilidade integral do usuário;</li>
        <li>
          Utilizados apenas para geração do documento solicitado.
        </li>
      </ul>
    </section>

    <section>
      <h4 className="font-semibold">2. Dados de Pagamento</h4>
      <p>
        Os pagamentos são processados por terceiros especializados.
        A Neo Modelos não coleta nem armazena dados financeiros ou de cartão.
      </p>
    </section>

    <section>
      <h4 className="font-semibold">3. Finalidade do Tratamento</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>Permitir acesso e uso da plataforma;</li>
        <li>Autenticação do usuário;</li>
        <li>Geração de documentos em PDF;</li>
        <li>Comunicações relacionadas ao serviço;</li>
        <li>Suporte ao usuário;</li>
        <li>Cumprimento de obrigações legais.</li>
      </ul>
    </section>

    <section>
      <h4 className="font-semibold">4. Armazenamento e Segurança</h4>
      <p>
        Os dados são armazenados em infraestrutura da Amazon Web Services (AWS),
        seguindo padrões reconhecidos de segurança da informação.
      </p>
    </section>

    <section>
      <h4 className="font-semibold">5. Compartilhamento de Dados</h4>
      <p>A Neo Modelos não vende ou aluga dados pessoais, exceto:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Quando necessário para a operação da plataforma;</li>
        <li>Para cumprimento de obrigação legal ou ordem judicial.</li>
      </ul>
    </section>

    <section>
      <h4 className="font-semibold">6. Cookies</h4>
      <p>
        Utilizamos cookies para funcionamento do sistema, melhoria da
        experiência e análises estatísticas básicas.
      </p>
    </section>

    <section>
      <h4 className="font-semibold">7. Direitos do Usuário</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>Confirmação do tratamento;</li>
        <li>Acesso, correção ou exclusão;</li>
        <li>Limitação ou oposição ao tratamento;</li>
        <li>Informações sobre compartilhamento.</li>
      </ul>
    </section>

    <section>
      <h4 className="font-semibold">8. Retenção de Dados</h4>
      <p>
        Os dados são mantidos apenas pelo tempo necessário ou conforme exigido
        por lei.
      </p>
    </section>

    <section>
      <h4 className="font-semibold">9. Alterações</h4>
      <p>
        Esta Política poderá ser atualizada a qualquer momento. Recomenda-se
        revisão periódica.
      </p>
    </section>

    <section>
      <h4 className="font-semibold">10. Contato</h4>
      <p>
        📧 <strong>suporte.neomodelos@gmail.com</strong>
      </p>
    </section>
  </div>
);

export const TermsOfService = () => (
  <div className="space-y-6">
    {/* Header */}
    <section>
      <h3 className="font-semibold">Termos de Uso</h3>
      <p className="text-xs text-muted-foreground">
        Última atualização: 01/02/26
      </p>
    </section>

    {/* Intro */}
    <p>
      Estes Termos de Uso regulam o acesso e a utilização do site e da plataforma
      digital de modelos de documentos (<strong>“Plataforma”</strong>), que
      disponibiliza modelos contratuais para preenchimento automático de dados
      e geração de documentos em formato PDF, mediante pagamento de mensalidade.
    </p>

    <p>
      Ao acessar ou utilizar a Plataforma, o usuário declara que leu, compreendeu
      e concorda integralmente com estes Termos. Caso não concorde, não deverá
      utilizar os serviços.
    </p>

    {/* 1 */}
    <section>
      <h4 className="font-semibold">1. Definições</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <strong>Plataforma:</strong> site e sistema online que permite a geração
          de documentos a partir de modelos pré-definidos.
        </li>
        <li>
          <strong>Usuário:</strong> pessoa física ou jurídica que realiza cadastro
          e utiliza a Plataforma.
        </li>
        <li>
          <strong>Modelos:</strong> modelos de documentos disponibilizados para
          preenchimento automático.
        </li>
        <li>
          <strong>Assinatura:</strong> plano pago que concede acesso aos recursos
          da Plataforma durante sua vigência.
        </li>
      </ul>
    </section>

    {/* 2 */}
    <section>
      <h4 className="font-semibold">2. Objeto do Serviço</h4>
      <p>
        A Plataforma tem como objetivo fornecer modelos de documentos editáveis,
        permitindo ao usuário inserir informações e gerar documentos em PDF de
        forma automatizada.
      </p>
      <p className="mt-2">
        A Plataforma não presta assessoria jurídica, nem substitui a análise de
        um advogado. Os modelos são padronizados e podem necessitar de
        adaptações conforme o caso concreto.
      </p>
    </section>

    {/* 3 */}
    <section>
      <h4 className="font-semibold">3. Cadastro do Usuário</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          O usuário deverá fornecer informações verdadeiras, completas e
          atualizadas.
        </li>
        <li>
          É responsável pela confidencialidade de seu login e senha e por todas
          as atividades realizadas em sua conta.
        </li>
        <li>
          É proibido compartilhar conta ou credenciais com terceiros, salvo
          autorização expressa da Plataforma.
        </li>
      </ul>
    </section>

    {/* 4 */}
    <section>
      <h4 className="font-semibold">4. Assinatura, Pagamentos e Acesso</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          O acesso aos modelos e à geração de documentos depende da contratação
          de um plano de assinatura.
        </li>
        <li>
          Cada plano possui limite mensal de geração de documentos, informado no
          momento da contratação.
        </li>
      </ul>

      <p className="mt-2 font-medium">
        Planos para imobiliárias:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Imobiliária Básico: até 3 usuários;</li>
        <li>Imobiliária Plus: até 5 usuários;</li>
        <li>Imobiliária Premium: até 20 usuários.</li>
      </ul>

      <ul className="list-disc pl-5 space-y-1 mt-2">
        <li>
          Valores, periodicidade e benefícios serão informados no momento da
          contratação.
        </li>
        <li>
          O não pagamento, extrapolação de limites ou uso indevido poderá gerar
          suspensão ou restrição de acesso.
        </li>
        <li>
          A Plataforma poderá alterar valores, planos e limites mediante
          comunicação prévia.
        </li>
      </ul>
    </section>

    {/* 5 */}
    <section>
      <h4 className="font-semibold">5. Uso Permitido e Restrições</h4>
      <p>O usuário poderá utilizar os documentos conforme o plano contratado.</p>
      <p className="mt-2 font-medium">É expressamente proibido:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Revender, redistribuir ou comercializar os modelos;</li>
        <li>
          Copiar ou modificar modelos para criação de produtos concorrentes;
        </li>
        <li>
          Utilizar a Plataforma para fins ilegais, fraudulentos ou contrários à
          legislação vigente;
        </li>
        <li>
          Tentar acessar áreas restritas ou sistemas sem autorização.
        </li>
      </ul>
    </section>

    {/* 6 */}
    <section>
      <h4 className="font-semibold">6. Propriedade Intelectual</h4>
      <p>
        Todos os modelos, textos, layouts, marcas, sistemas e funcionalidades
        são protegidos por direitos autorais e pertencem exclusivamente à
        Plataforma ou a seus licenciadores.
      </p>
      <p className="mt-2">
        A assinatura concede apenas uma licença limitada, não exclusiva e
        temporária de uso, sem transferência de propriedade intelectual.
      </p>
    </section>

    {/* 7 */}
    <section>
      <h4 className="font-semibold">7. Responsabilidade do Usuário</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          O usuário é o único responsável pelas informações inseridas nos
          documentos.
        </li>
        <li>
          A Plataforma não se responsabiliza por erros decorrentes de dados
          incorretos ou incompletos.
        </li>
      </ul>
    </section>

    {/* 8 */}
    <section>
      <h4 className="font-semibold">8. Limitação de Responsabilidade</h4>
      <p>
        A Plataforma não garante que os documentos atenderão a todas as
        necessidades específicas do usuário ou legislações locais.
      </p>
      <p className="mt-2">
        Em nenhuma hipótese a Plataforma será responsável por perdas, danos ou
        prejuízos decorrentes do uso ou impossibilidade de uso dos documentos.
      </p>
    </section>

    {/* 9 */}
    <section>
      <h4 className="font-semibold">9. Cancelamento e Rescisão</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>O usuário poderá cancelar a assinatura conforme regras do plano.</li>
        <li>
          A Plataforma poderá encerrar contas que violem estes Termos, sem
          reembolso.
        </li>
      </ul>
    </section>

    {/* 10 */}
    <section>
      <h4 className="font-semibold">10. Alterações dos Termos</h4>
      <p>
        Estes Termos poderão ser modificados a qualquer momento, entrando em
        vigor após sua publicação.
      </p>
    </section>

    {/* 11 */}
    <section>
      <h4 className="font-semibold">11. Legislação Aplicável e Foro</h4>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do Brasil.
      </p>
      <p className="mt-2">
        Fica eleito o foro da comarca do domicílio do responsável pela Plataforma,
        salvo disposição legal em contrário.
      </p>
    </section>

    {/* 12 */}
    <section>
      <h4 className="font-semibold">12. Contato</h4>
      <p>
        Em caso de dúvidas, o usuário poderá entrar em contato pelos canais
        informados na Plataforma.
      </p>
    </section>
  </div>
);

export default TermsOfService;

